import { useEffect, useContext, useState } from "react";
import { useParams } from "react-router";
import t from "../locales";
import Post from "../components/post";
import fetchPosts from "../helpers/fetch_helper";
import CATEGORIES from "../data/categories";
import { PostsContext } from "../app";

export default function DashboardPosts() {
  const { category: categoryKey, id } = useParams();
  const category = CATEGORIES[categoryKey];
  const { posts, setPosts } = useContext(PostsContext);
  const [showAllPosts, setShowAllPosts] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (category === undefined) return;

    if (posts.length === 0) {
      async function loadPosts() {
        const fetchedPosts = await fetchPosts(id, category);
        if (!fetchedPosts) {
          setError(t("dashboard.error.other"));
          return;
        }
        setPosts(fetchedPosts);
      }
      loadPosts();
    }
  }, [category, id, posts.length, setPosts]);

  const handleTogglePosts = async () => {
    const fetchedPosts = await fetchPosts(
      showAllPosts ? id : undefined,
      category,
    );
    if (!fetchedPosts) {
      setError(t("dashboard.error.other"));
      return;
    }
    setError("");
    setPosts(fetchedPosts);
    setShowAllPosts(!showAllPosts);
  };

  if (category === undefined) {
    return (
      <p className="dashboard__error">{t("dashboard.error.unavailable")}</p>
    );
  }

  return (
    <>
      <title>{t("dashboard.posts.title")}</title>
      <div className="dashboard-posts">
        <div className="dashboard-posts__header">
          <h1 className="dashboard-posts__title">
            {t("dashboard.posts.heading")}
          </h1>
          <div className="dashboard-posts__meta">
            <p className="dashboard-posts__classcode">
              {t("dashboard.posts.classCode")}: {id}
            </p>
            <button
              type="button"
              onClick={handleTogglePosts}
              className="dashboard-posts__link"
            >
              {showAllPosts
                ? t("dashboard.posts.backToClass")
                : t("dashboard.posts.openLink")}
            </button>
          </div>
        </div>
        {error && <p className="dashboard-posts__error">{error}</p>}
        <div className="dashboard-posts__list">
          {posts.map((post) => (
            <Post
              key={post.id}
              post={post}
              showNavigation={true}
              showHideButton={true}
            />
          ))}
        </div>
      </div>
    </>
  );
}
